<template>
  <!-- <div class="pb-2 pt-2 border-b border-solid border-gray-100 dark:border-darkblue-600"> -->
  <div class="pb-4">
    <label class="text-sm font-semibold text-secondary-600 block mb-1 ml-4">{{ nombre }}</label>
    <div class="flex flex-row justify-center items-start">
      <div
        class="filters-applied flex flex-row w-full flex-wrap items-start content-start border-solid border-primary-200 dark:border-darkblue-600 border rounded-3xl p-2"
        style="min-height: 100px"
      >
        <base-filter-tag-item-searches
          v-for="tag in tags"
          :key="tag[0]"
          :tag="tag"
        />
      </div>
      <div class="p-4">
        <base-button-icon name="check" size="xs" iconSize="sm" mode="primary" class="mb-2" @click="applySearch" ariaLabel="Aplicar la búsqueda a los filtros"/>
        <base-button-icon name="trash" size="xs" iconSize="sm" mode="secondary" @click="deleteSearch" ariaLabel="Eliminar búsqueda"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'base-search-item',
  props: {
    tags: {
      type: [Array],
      required: true
    },
    id: {
      type: Number,
      required: true,
      default: -1
    },
    nombre: {
      type: String,
      required: true
    }
  },
  computed: {
    hasTags: function () {
      return this.tags.length > 0
    }
  },
  methods: {
    deleteSearch: function () {
      this.$emit('deleteSearch', this.id)
    },
    applySearch: function () {
      const tagsToObj = this.convertTagsToObject()
      this.$emit('applySearch', tagsToObj)
    },
    convertTagsToObject () {
      const tags = this.tags
      let obj = {}
      for (let i = 0; i < tags.length; i++) {
        const objAux = {
          label: tags[i][1],
          value: tags[i][2],
          labelValue: tags[i][3]
        }
        const objAux2 = { [tags[i][0]]: objAux }
        obj = Object.assign(obj, objAux2)
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped></style>
